module.exports = __webpack_public_path__ + "static/media/placeholder_image_panoramic.0671a79c.svg";